export interface ScannedProduct {
  title: string
  editionLabel: string
  priceNumber: number
  priceText: string
  thumbnailUrl: string
}

export function scanProducts(): ScannedProduct[] {
  const products: ScannedProduct[] = []

  // 1. Try JSON-LD
  const scripts = document.querySelectorAll(
    'script[type="application/ld+json"]',
  )
  scripts.forEach((script) => {
    try {
      const data = JSON.parse(script.textContent || '')
      const items = Array.isArray(data) ? data : [data]

      items.forEach((item) => {
        if (item['@type'] === 'Product' || item['@type'] === 'Offer') {
          let price = 0
          let priceText = ''
          if (item.offers) {
            const offer = Array.isArray(item.offers)
              ? item.offers[0]
              : item.offers
            price = offer.price ? parseFloat(offer.price) : 0
            priceText = offer.priceCurrency
              ? `${offer.priceCurrency} ${price}`
              : `$${price}`
          } else if (item.price) {
            price = parseFloat(item.price)
            priceText = item.priceCurrency
              ? `${item.priceCurrency} ${price}`
              : `$${price}`
          }

          products.push({
            title: item.name || document.title,
            editionLabel: 'Digital Edition',
            priceNumber: price,
            priceText: priceText,
            thumbnailUrl:
              item.image ||
              'https://cdn.magicpatterns.com/uploads/vEJPcjkGj9kf8sva5bDKmh/PortadaProducto.png',
          })
        }
      })
    } catch (e) {
      // Ignore JSON parse errors
    }
  })

  // 2. Scan DOM for price-like strings near CTA
  if (products.length === 0) {
    const ctaElements = document.querySelectorAll(
      'button, a, .offer-card, [id*="offer"]',
    )
    ctaElements.forEach((el) => {
      const text = el.textContent || ''
      if (/(comprar|añadir|checkout|order|quiero|obtener|\$)/i.test(text)) {
        const priceMatch = text.match(/\$\s?(\d+(?:\.\d{3})*(?:,\d{2})?)/)
        if (priceMatch) {
          const priceStr = priceMatch[1].replace(/\./g, '').replace(',', '.')
          const priceNum = parseFloat(priceStr)

          // Try to find an image nearby
          let imgUrl =
            'https://cdn.magicpatterns.com/uploads/vEJPcjkGj9kf8sva5bDKmh/PortadaProducto.png'
          const container = el.closest('section') || el.closest('div')
          if (container) {
            const img = container.querySelector('img')
            if (img && img.src) {
              imgUrl = img.src
            }
          }

          products.push({
            title: document.title || 'Protocolo de Calma',
            editionLabel: 'Edición Digital',
            priceNumber: priceNum,
            priceText: priceMatch[0],
            thumbnailUrl: imgUrl,
          })
        }
      }
    })
  }

  // Deduplicate by price and title
  const uniqueProducts: ScannedProduct[] = []
  const seen = new Set()
  for (const p of products) {
    const key = `${p.title}-${p.priceNumber}`
    if (!seen.has(key)) {
      seen.add(key)
      uniqueProducts.push(p)
    }
  }

  if (uniqueProducts.length > 0) {
    return uniqueProducts
  }

  // Fallback
  return [
    {
      title: 'Pack Despertar / Physical Book',
      editionLabel: 'Physical Book',
      priceNumber: 27,
      priceText: '$27',
      thumbnailUrl:
        'https://cdn.magicpatterns.com/uploads/vEJPcjkGj9kf8sva5bDKmh/PortadaProducto.png',
    },
    {
      title: 'Edición Digital / Digital Edition',
      editionLabel: 'Digital Edition',
      priceNumber: 17,
      priceText: '$17',
      thumbnailUrl:
        'https://cdn.magicpatterns.com/uploads/vEJPcjkGj9kf8sva5bDKmh/PortadaProducto.png',
    },
  ]
}
